import { IFormViewForm } from 'components/FormView';

const LoadPurchaseOrderForm: IFormViewForm = {
    id: 'LoadPurchaseOrderForm',
    layout: {
        rows: 1,
        columns: 1
    },
    fields: [
        {
            id: '1',
            position: {
                row: 1,
                col: 1,
                colspan: 3
            },
            type: 'PAPER_CONTAINER',
            props: {
                elevation: 0
            },
            children: [
                {
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Purchase order',
                        name: 'LoadFromPurchaseOrder',
                        size: 'medium',
                        lookupName: 'WarehouseSupplierPurchaseOrder',
                        isLookupTypeFixed: false,
                        searchScreenTitle: 'Purchase Order Lookup',
                        isWarehouseSupplierScoped: true,
                        required: true
                    }
                },
            ]
        }
    ]
};
export default LoadPurchaseOrderForm;
